import images from './images';

const Menu = [
    {
        text: 'Contact us',
        link: '/home#contact',
    },
    {
        text: 'Courses',
        link: '/home#courses',
    },
    {
        text: 'Desire',
        link: '/home#desire',
    },
    {
        text: 'Process',
        link: '/home#process',
    },
    {
        text: 'Team',
        link: '/home#team',
    },
    {
        text: 'Testimonials',
        link: '/home#testimonials',
    },
    {
        text: 'Ai For Gen Z',
        link: '/home#courses',
    }
];
const ServicesData = [
    {
        titleone: 'Ai for Gen Z',
        titletwo: 'Machine Learning & Deep Learning with Python',
        link: '#',
        itemclass: 'blight',
        imgURL: images.services01,
    },
    {
        titleone: 'Ai for Kids',
        titletwo: 'Kids Friendly Machine Learning & Deep Learning',
        link: '#',
        itemclass: 'blight',
        imgURL: images.services02,
    },
    {
        titleone: 'Advanced Generative Ai',
        titletwo: 'Upcoming',
        link: '#',
        itemclass: 'blight',
        imgURL: images.services05,
    },
    {
        titleone: 'Advanced Computer Vision',
        titletwo: 'Upcoming',
        link: '#',
        itemclass: 'blight',
        imgURL: images.services06,
    },
]
const CaseStudies = [
    {
        title:"Gen Z এর প্রতি নিবেদন:",
        text: 'তোমরা যারা নতুন প্রজন্ম আছ তোমাদের সাহস, পরিকল্পনা, উদ্যেম ও চিন্তা-চেতনা ইতোমধ্যে পরিক্ষীত। জাতি তোমাদের চিন্তা-চেতনাকে সম্মান করে। আমরা দেখেছি একটা সঠিক সিদ্ধান্ত একটি জীবন নয় শুধু একটা জাতিকেও পাল্টে দিতে পারে। আশা করি তোমরা সঠিক সিদ্ধান্ত নিতে কখনো ভুল করবেনা। আগামীর বিশ্বটাকে যদি আমাদের করে নিতে চাই তাহলে- Ai তে তোমাদের দক্ষ হতেই হবে; এই লক্ষ্যে আমাদের কাছে কোর্স করতে হবে তা নয়, আমাদের "Course Plan" এ উল্লেখিত মডিউল গুলো যেকোনো জায়গা থেকে শিখে নিয়ে বাস্তব জীবনে প্রয়োগ করতে পারলেই চলবে।',
        link: '#',
    },
    {
        title:"অভিভাবকবৃন্দের প্রতি নিবেদন:",
        text: 'প্রিয় অবিভাবকবৃন্দ, আপনার সন্তান ডাক্তার, প্রকৌশলী, আইনজীবী, শিক্ষক, ব্যবসায়ী যে পেশাতেই পদার্পন করুক না কেন তাকে নিশ্চই বাংলাভাষা, নূন্যতম ইংরেজী ভাষা, ন্যূনতম গণিত, ন্যূনতম বিজ্ঞান, ন্যূনতম আইন ইত্যাদি জানা লাগবে; বর্তমান যুগে Ai (Artificial intelligence) এরকমই বিষয় যার ন্যূনতম জ্ঞান সবারই থাকতে হবে অন্যথায় সে শীঘ্রই পিছিয়ে পড়বে। তাই আপনার সন্তানকে Ai শিক্ষা দিন এবং নিজেও এই শিক্ষা অর্জন করুন।',
        link: '#',
    },
    {
        title:"সরকারের প্রতি নিবেদন:",
        text: 'স্বাধীনতার অর্ধশত বছর পেরিয়ে গেলেও কোনো এক অজানা শক্তি এ জাতিকে রাজনৈতিক বৃত্তে আটকে রেখেছে। ২য় বিশ্বযুদ্ধে বিধ্বস্ত জাপান অর্ধশত বছর পার না হতেই টেকনোলজিতে বিশ্বকে নেতৃত্ব দিয়েছে অথচ আমরা অর্ধশত বছর পরে এখনো সেই স্বপ্নতেই আছি। স্বপ্ন দেখা ভালো, আমরা স্বপ্ন দেখছিও কিন্তু তা বাস্তবায়নের পথ তৈরি করে দেয়ার দায়িত্ব সরকারের।',
        link: '#',
    },
];

const WorkingProcess = [
    {
        title: 'সপ্তাহে ৩ দিন ক্লাশ',
        description: 'প্রতিটি ব্যাচের জন্য প্রতি একদিন পর পর ক্লাশ থাকবে। যেদিন ক্লাশ হবে পরের দিন তা অনুশীলন করার জন্য সময় দেওয়া হয়, তাই ঐদিন ক্লাশ থাকেনা। ক্লাশের সময় এমনভাবে নির্ধারণ করা হয় যেন সবাই উপস্থিত থাকতে পারে।',
    },
    {
        title: '২ ঘন্টা ব্যাপী ক্লাশ',
        description: 'প্রতিটি ক্লাশ ২ ঘন্টা ব্যাপী হলেও আমাদের Targeted topic শেষ না হওয়া অবদি ক্লাশ চলবে, তবে Targeted topic দ্রুত শেষ হয়ে গেলে সেক্ষেত্রে ২ ঘন্টার আগেও ক্লাশ শেষ হতে পারে।',
    },
    {
        title: 'লেকচার শীট ও ক্লাশ রেকর্ড',
        description: 'প্রতিটি ক্লাশ শেষে ঐ ক্লাশের লেকচার শীট গুগল ক্লাশরুমে আপলোড করা হয়, অনুমোদিত প্রশিক্ষনার্থী যেকোনো সময় তা ডাউনলোড করতে পারবে। একই সাথে ক্লাশ রেকর্ডিং এর লিঙ্কও দেয়া হবে যা পরবর্তীতে শুধু দেখা যাবে তবে ডাউনলোড করা যাবেনা।',
    },
    {
        title: 'মেসেঞ্জার গ্রুপে সমস্যার সমাধান',
        description: 'প্রশিক্ষণার্থী বাসায় অনুশীলন করতে গিয়ে কোনো সমস্যার সম্মুখীন হলে আমাদেরকে মেসেঞ্জারে নক করতে পারে, আমরা যত দ্রুত সম্ভব তার সমাধান দেয়ার চেষ্টা করি। মেসেঞ্জরে সমাধান দেয়ার ক্ষেত্রে শুধু প্রশিক্ষক নয় বরং অন্যান্য প্রশিক্ষনার্থীও অংশ নিতে পারবে। এককথায় মেসেঞ্জার গ্রুপটি আমাদের জন্য একটা মুক্ত আলোচনার ক্ষেত্র।',
    },
    {
        title: 'প্রতি ৫/৭ ক্লাশ অন্তর কুইজ',
        description: 'প্রতি ৫/৭ ক্লাশ পর পর আমরা কুইজ আয়োজন করি, যেখানে খুটিনাটি বিষয়ে প্রশিক্ষণার্থীকে প্রশ্ন করা হয় এবং তার অগ্রগতি যাচাই করা হয়। যদি কেউ পিছিয়ে থাকে তার কারণ উদঘাটন ও সমাধানের চেষ্টা করা হয়; এমনকি কোনো সময় এক্সট্রা ক্লাশের প্রয়োজন হলে তাও আমরা নিয়ে থাকি। এককথায় কেউ পিছিয়ে থাকতে পারবেনা।',
    },
    {
        title: 'মডিউল শেষে প্রজেক্ট',
        description: 'প্রতিটি মডিউল শেষ হলে উক্ত মডিউলের উপর প্রশিক্ষনার্থীকে প্রজেক্ট জমা দিতে হয়। প্রশিক্ষনার্থী কি পরিমাণ প্র্যাকটিক্যাল জ্ঞান অর্জন করেছে তা প্রজেক্টেই প্রমাণ হবে। যতক্ষন অবদি একজন প্রশিক্ষণার্থী ভাল মানের প্রজেক্ট জমা দিতে পারবেনা ততক্ষণ তাকে সহযোগিতা করা হয়।',
    },
    {
        title: 'ফাইনাল প্রজেক্ট',
        description: 'কোর্স শেষে যারা ফাইনাল প্রজেক্ট জমা দিতে পারে তাদের Ai For Today এর পক্ষ থেকে সনদ দেয়া হয়। সনদে তার সম্পূর্ণ করা সকল মডিউলের নাম উল্লেখ থাকে।',
    },
    {
        title: 'বৃত্তি প্রদান',
        description: 'কোর্স শেষে পারফরম্যান্স, মনোযোগ, চেষ্টা, আচরণ ও উপস্থিতির উপর ভিত্তি করে ১ জনকে ১০০% এবং ২ জনকে ৫০% বৃত্তি প্রদান করা হয়। অর্থাৎ প্রশিক্ষানার্থী যে মূল্য দিয়ে রেজিস্ট্রেশন করেছে বৃত্তি হিসেবে ১ জনকে তার প্রদানকৃত সম্পুর্ণ মূল্য এবং ২ জনকে তাদের প্রদানকৃত মূল্যের অর্ধেক মূল্য ফেরত দেয়া হয়।',
    },
];

const Team = [
    {
        name: 'Hefaj Uddin\n(Statician & Engineer)',
        position: 'CEO, Founder, Trainer Head',
        info: 'B.Sc in Statistics, IsDB Scholar in .NET \n Specialist in Statistical Machine Learning and Data Science.',
        foto: images.team01,
        linkedin: 'www.linkedin.com/in/hefajuddin',
    },
    {
        name: 'AHM Hasnat Hafiz\n(Engineer)',
        position: 'Trainer & Advisor',
        info: 'B.Sc in CSE M.Sc (USA),\n Specialist Data Science, Python and Java.',
        foto: images.team02,
        linkedin: 'https://www.linkedin.com/in/hafiz229',        
    },
    {
        name: 'Md Anik Chowdhury\n(Engineer)',
        position: 'Trainer',
        info: 'B.Sc in CSE, \n Specialist in Data Science and Machine Learning',
        foto: images.team03,
        linkedin: '#',
    },
    {
        name: 'Ishra Naznin\n(Engineer)',
        position: 'Trainer',
        info: 'B.Sc in CSE, M.Sc (University of Chittagong) \n 2+ years experience in teaching in ICT, Cantonment Public School & College, Chittagong.',
        foto: images.team04,
        linkedin: '#',
    },
    {
        name: 'Syed Nur Mostafa\n(Adv.)',
        position: 'Ligal Advisor',
        info: 'LLB-LLM, Practioner in Chittagong Court, \n Expert in law specially Copyright, Data source and forensic rules.',
        foto: images.team05,
        linkedin: '#',
    },
    {
        name: 'Bagdad Ahmed',
        position: 'Advisor',
        info: 'B.Sc in Pharmacy, PhD in Drug Toxicity (Ohio State University, USA) \n Researcher of Medical, Drugs, Disease and other sensetive data.',
        foto: images.team06,
        linkedin: 'https://www.linkedin.com/in/bagdad-ahmed',
    },

];

const Testimonials = [
    {
        name: 'Ariful Islam',
        position: 'Student of batch- GenZ101',
        testimonial: '“আমি মানবিক বিভাগ থেকে এসএসসি পাশ করেছি। Ai For Today এর কোর্সে এমন কোনো টপিক নেই যা আমি কাভার করতে পারিনি। যতবারই ইচ্ছা হয় আপনি প্রশিক্ষককে প্রশ্ন করতে পারবেন।"',
    },
    {
        name: 'Forhad Bin Faruk',
        position: 'Student of batch- GenZ201',
        testimonial: '“Ai For Today এর ট্রেইনাররা খুব সহজ উদাহরণ দিয়ে বুঝাতে পারেন, তাই না বুঝে পার পাওয়া এতটা সহজ নয়। তারা তরুনদের কথা মাথায় রেখেই কোর্সপ্ল্যান তৈরি করেছে; খুবই সমৃদ্ধ।"',
    },
    {
        name: 'Riyad Morshed',
        position: 'Student of batch- GenZ301',
        testimonial: '“Ai For Today এর প্রজেক্টগুলো করলে এমনিতেই সবকিছু ক্লিয়ার হয়ে যায়, তাদের প্রজেক্টগুলো রিয়েল প্রজেক্টের মতই; রিয়েল লাইফে ডাটা নিয়ে কাজ করতে কোনো অসুবিধা হবেনা।"',
    },
    {
        name: 'Md. Hasan Uddin',
        position: 'Student of batch- GenZ401',
        testimonial: '“এদের মডিউল লিস্টটা খুবই সমৃদ্ধ; এটা ভালভাবে শেষ করতে পারলে চাকরির কোনো অভাব হবেনা। শুধু দেশে নয় দেশের বাইরের ইন্টারভিউতে ভাল সাড়া পাচ্ছি। আশা করি ভাল কিছু হবে।"',
    },
];
export default { Menu, CaseStudies, WorkingProcess, Team, Testimonials, ServicesData };